import { render } from "./ChapterCOMP.vue?vue&type=template&id=0b043bee&scoped=true"
import script from "./ChapterCOMP.vue?vue&type=script&lang=js"
export * from "./ChapterCOMP.vue?vue&type=script&lang=js"

import "./ChapterCOMP.vue?vue&type=style&index=0&id=0b043bee&lang=scss&scoped=true"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b043bee"]])

export default __exports__